import { ServicesProperty } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
  VariantFilter,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { makePropertyFilterData } from '../../../makeFilterAndOrderData';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * InitialFilterProcessor формирует начальные данные фильтров для всех вариантов
 */
export class InitialFilterProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const filterData: { [T in string]: VariantFilter } = {};
    const options = { ...servicePropertyCacheState };

    // Собираем все доступные свойства услуг в мапу по ID
    const allProperties: { [T in string]: ServicesProperty } = {};
    const props = [
      ...additionalServiceState.PropertiesToDisplay,
      ...Object.values(additionalServiceState.VariantProperties).flat(1),
    ];
    props.map((p) => (allProperties[p.id] = p));

    // Для каждого варианта генерируем базовые данные по фильтру
    Object.keys(additionalServiceState.PropertyValues).map((variantID) => {
      filterData[variantID] = {
        IsSortChanged: false,
        ServicePriority: {},
        ServiceVisibility: {},
        Data: {},
        IsPriceFilterAvailable: false,
        IsSortByProperty: false,
        PriceFilter: {
          Min: 0,
          Max: 0,
          CurrentMin: 0,
          CurrentMax: 0,
        },
        PropertyToSort: '',
        SortDirection: 'asc',
      };

      // Обходим все свойства, выводимые в варианте и генерируем для
      // каждого данные по фильтрации.
      Object.keys(additionalServiceState.PropertyValues[variantID]).map((propID) => {
        const property = allProperties[propID];
        if (!property || !options.Options[variantID]) {
          return;
        }

        filterData[variantID].Data[property.id] = makePropertyFilterData(
          property,
          additionalServiceState.PropertyValues[variantID][property.id],
          options.Options[variantID][property.id] ?? []
        );
      });
    });

    return {
      isValid: true,
      additionalServiceState,
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState: {
        ...servicePropertyFilterAndOrderState,
        Variants: { ...filterData },
      },
    };
  }
}
